import { gql } from '@apollo/client';

export const REMOVE_ATTACHMENT = gql`
  mutation removeAttachment($input: RemoveAttachmentInput!) {
    removeAttachment(input: $input) {
      errors
    }
  }
`

